import React from 'react';
import { Fade, Grid, Typography, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { navigate } from '../../actions/routerResolve';
import { colors } from '../../styles';

const Notfound = props => (
    <Fade in={true} style={{ width:"100%", height:"80%"}}>
        <Grid container style={{ justifyContent: "center", alignItems: "center", textAlign: "center", padding:15}}>
            <Grid style={{textAlign:"center"}}>
                <Typography variant="display4">{props.code || 404}</Typography>
                <Typography variant="title" style={{color:colors.regular}}>{props.message || "Essa página não existe."}</Typography>
                <Button 
                    variant="contained" 
                    size="large"
                    color="primary"
                    style={{marginTop:20}}
                    onClick={()=>props.navigate("/")}
                >
                    Voltar ao Início
                </Button>
            </Grid>
        </Grid>
    </Fade>
)
const mapStateToProps = () => ({
    
})

const mapDispatchToProps = {
    navigate
};

export default connect(mapStateToProps, mapDispatchToProps)(Notfound)


// WEBPACK FOOTER //
// ./src/routes/errors/NotFound.js